import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/public/store/`;

export const axiosInstancePublic = axios.create({ baseURL: BASE_URL });
